import { NICmsContentField } from '@icms/core/content';
import { NICmsContentPageType } from '@icms/core/content/interfaces/icms-content-page-type.interfaces';
import { BLOG_TAB } from '../root/cms-blog-root.interface';
import { NCmsBlogCategory } from './cms-blog-category.interface';

export const CMS_BLOG_CATEGORY_CONFIG = <NICmsContentPageType.IMeta>{
    id: NCmsBlogCategory.typeId,
    title: 'Blog category',
    fields: [
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.useParent',
            title: 'Use parent category content',
            default: true,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.topCopy',
            title: 'Top copy',
            canShow: (data: NCmsBlogCategory.ITypeData) => !data?.useParent,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.tagRedirect',
            title: 'Redirect location on tag change',
            default: true,
            tab: BLOG_TAB
        },
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'Component',
            default: []
        }
    ],
    initData: {
        components: []
    }
};
